import { apiRequest } from '../api/client';
import type { InvoiceType } from './api';

/** Matches `apps/api` `StoredFiscalPointOfSale` (`fiscal-point-of-sale.repository.ts`). */
export interface FiscalPointOfSale {
  id: string;
  number: number;
  description: string;
  invoiceTypes: InvoiceType[];
  isActive: boolean;
  lastNumberByType: Record<string, number>;
  createdAt: string;
  updatedAt: string;
  /** Operating unit ("Punto de venta") this ARCA point is linked to, if any. */
  operatingUnit: { id: string; name: string } | null;
}

/** Matches `apps/api` `GET /fiscal-points-of-sale`. */
export function listFiscalPointsOfSale(): Promise<FiscalPointOfSale[]> {
  return apiRequest<FiscalPointOfSale[]>('/fiscal-points-of-sale');
}

export interface CreateFiscalPointOfSaleInput {
  number: number;
  description: string;
  invoiceTypes: InvoiceType[];
}

/** Matches `apps/api` `POST /fiscal-points-of-sale`. */
export function createFiscalPointOfSale(
  input: CreateFiscalPointOfSaleInput,
): Promise<FiscalPointOfSale> {
  return apiRequest<FiscalPointOfSale>('/fiscal-points-of-sale', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export interface UpdateFiscalPointOfSaleInput {
  description?: string;
  invoiceTypes?: InvoiceType[];
  isActive?: boolean;
}

/** Matches `apps/api` `PATCH /fiscal-points-of-sale/:id`. */
export function updateFiscalPointOfSale(
  id: string,
  input: UpdateFiscalPointOfSaleInput,
): Promise<FiscalPointOfSale> {
  return apiRequest<FiscalPointOfSale>(`/fiscal-points-of-sale/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(input),
  });
}
